import { render, staticRenderFns } from "./MemberMenu.vue?vue&type=template&id=5f2aba64&"
import script from "./MemberMenu.vue?vue&type=script&lang=js&"
export * from "./MemberMenu.vue?vue&type=script&lang=js&"
import style0 from "./MemberMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports